import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../base/base.component';

@Component({
  selector: 'app-do-bottom-toolbar',
  templateUrl: './do-bottom-toolbar.component.html',
  styleUrls: ['./do-bottom-toolbar.component.css'],
  standalone: false,
})
export class DoBottomToolbarComponent extends BaseComponent {}
